import { Button, Dialog, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";

export default function RegionsEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, region_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    id: region_id ? region_id : "null",
    dane_code: "",
    name: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (region_id) {
      ApiRequest({
        url: "/locationRegions/details",
        method: "get",
        headers: { ltkn: localStorage.getItem("ltkn") },
        query: { id: region_id },
        setResponse: (response: any) => {
          setFormValues(response.data);
        },
      });
    } else {
      setFormValues(defaultValues);
    }
  }, [region_id]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    await ApiRequest({
      url: "/locationRegions/addEdit",
      method: "post",
      headers: { ltkn: localStorage.getItem("ltkn") },
      body: formValues,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Región guardada con éxito", { variant: "success" });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: "502px" }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Región</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="dane_code"
              name="dane_code"
              label="Código DANE"
              type="text"
              required
              fullWidth
              value={formValues.dane_code}
              onChange={handleInputChange}
            />

            <TextField
              id="name"
              name="name"
              label="Nombre de la Región"
              type="text"
              required
              fullWidth
              value={formValues.name}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
